export default __webpack_public_path__ + "static/media/scansGreen.e4fb8d3d.png";